import { ToastManagerStore } from "@core/presentacion/component/feedback/toast-manager/toast-manager.store";
import { ProjectRepository } from "@project/data/repositories/project.repository";
import { ProjectListDashboardExportFormat } from "@project/domain/models/project-list-dashboard.model";
import { ProjectSearchFilters } from "@project/domain/models/project-search-filters";
import { inject, injectable } from "inversify";

@injectable()
export class ExportProjectListDashboardUseCase {
    constructor(
        @inject(ProjectRepository)
        private readonly projectRepository: ProjectRepository,
    ) {}

    async execute(
        format: ProjectListDashboardExportFormat,
        filters?: ProjectSearchFilters,
    ): Promise<Blob> {
        const dashboardResult =
            await this.projectRepository.exportProjectListDashboard(
                format,
                filters,
            );

        if (dashboardResult.isLeft()) {
            ToastManagerStore.error(dashboardResult.getLeftOrThrow().message);
        }

        return dashboardResult.getOrThrow();
    }
}
